var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('navbar',{on:{"open-login":_vm.handleLoginActive}}),_vm._v(" "),_c('login-modal'),_vm._v(" "),_c('section',{staticClass:"main-content"},[_c('nuxt'),_vm._v(" "),_c('cookie-banner')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }